export default __webpack_public_path__ + "static/ay-support-content-roadmap-and-upgrade-c36f3024ff3b12d473edebae173902ad.svg";